<script lang="ts">
	import type { SearchFieldProps } from 'utility/search-fields'
	import type { i18n } from 'types/common'

	import Pin from 'components/search/Pin.svelte'
	import EditModeControls from 'components/search/EditModeControls.svelte'

	import NullableRadioCheckbox from 'components/NullableRadioCheckbox.svelte'
	import { getContext } from 'svelte'

	interface Props extends SearchFieldProps<boolean | null> {
		checked?: boolean | null
	}

	let {
		searchField,
		inEditMode,
		pinnedSearchFields,
		selectedSearchFieldsKeys,
		checked = $bindable(null),
		change,
		...rest
	}: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<NullableRadioCheckbox
		{...rest}
		id={searchField?.key}
		label={translate('common:dismantled', 'Dismantled')}
		bind:value={checked}
		change={() => {
			change?.({ field: searchField, value: checked })
		}}
	>
		{#snippet hint()}
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		{/snippet}
	</NullableRadioCheckbox>
</EditModeControls>
